import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import { MicrosoftAuthService } from './data/service/auth/microsoft-auth.service';
import { SwUpdateService } from './data/service/sw-update.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public Entorno : string = environment.variableEntorno != 'Prod' ? environment.variableEntorno.toUpperCase() : '';

  constructor(private router: Router, private titleService: Title, private authService: MicrosoftAuthService, private swUpdateService: SwUpdateService) { }

  ngOnInit() {
    this.titleService.setTitle(`Mesa de Ayuda ${this.Entorno} | IEEG`);

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) { return; }
      window.scrollTo(0, 0);
    });
    this.authService.getUser();
  }
}